import React from 'react';
import { ChatHowItWorks } from 'services/api/chatsApi';
import styled from 'styled-components';

interface HowItWorksSectionProps {
  howItWorks: ChatHowItWorks[];
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ howItWorks }) => {
  if (!howItWorks || howItWorks.length === 0) return null;

  return (
    <HowItWorksSectionWrapper>
      <HowItWorksTitle>How It Works</HowItWorksTitle>
      <HowItWorksGrid>
        {howItWorks.map((item, index) => (
          <HowItWorksCard key={index}>
            <TitleWrapper>
              <CardNumber>{index + 1}.</CardNumber>
              <HowItWorksCardTitle>{item.title}</HowItWorksCardTitle>
            </TitleWrapper>
            <HowItWorksDescription>{item.description}</HowItWorksDescription>
          </HowItWorksCard>
        ))}
      </HowItWorksGrid>
    </HowItWorksSectionWrapper>
  );
};

export default HowItWorksSection;

const HowItWorksSectionWrapper = styled.section`
  margin-bottom: 48px;
  
  @media (max-width: 968px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const HowItWorksTitle = styled.h2`
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  color: #FFF;
  text-align: left;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 24px;
  }
`;

const HowItWorksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  
  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const HowItWorksCard = styled.div`
  border-radius: 12px;
  border: 1px solid var(--Premium-Premium, #9E5EEE);
  background: var(--Premium-PremiumOverlay, linear-gradient(90deg, rgba(158, 94, 238, 0.15) 0%, rgba(183, 89, 234, 0.15) 32%, rgba(198, 93, 233, 0.15) 66%, rgba(184, 133, 244, 0.15) 100%));
  padding: 16px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    padding: 14px;
    min-height: 100px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
`;

const CardNumber = styled.span`
  color: #FFF;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  flex-shrink: 0;
`;

const HowItWorksCardTitle = styled.h3`
  color: #FFF;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 110% */
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 20px;
  }
`;

const HowItWorksDescription = styled.p`
  overflow: hidden;
  color: #FFF;
  text-overflow: ellipsis;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: stretch;
  flex-grow: 1;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 16px;
  }
`; 